import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IonInfiniteScroll, ModalController} from '@ionic/angular';
import { GlobalService } from './../../../../config/services/global.service';

@Component({
    selector: 'app-modal-banco',
    templateUrl: './modal-banco.component.html',
    styleUrls: ['./modal-banco.component.scss'],
})
export class ModalBancoComponent implements OnInit {
    @ViewChild('bancoSearchBar')bancoSearchBar;
    
    @Input() select: string;
    @Input() tipo: string;

    public bancoList:any;
	  public loadBanco:    boolean = true;
    public loadBancoIni: boolean = false;
    public showSearch:    boolean = false;
    public from: any;
    public itemSelect = [];

  	constructor( 
  		private globalService: GlobalService,
  		private router: Router,
  		public  modalController: ModalController
  	) {
  		this.bancoList = {list: [], page: 0, pages: 0, iTotal: 0, search: ''}
  	}

  	ngOnInit() {
  		if(this.globalService.selects.bancos.length <= 0){
        	this.list('ini', null, 'Cargando...');
  		}else{
  			this.bancoList.list = this.globalService.selects.bancos;
  		}
        this.focusSearch();
  	}
    
    focusSearch() {
        setTimeout(() =>{
        	this.bancoSearchBar.setFocus();
        },400);
    }

  	async list(from, ev, loadinSMS) {
  		const token       = await this.globalService.getToken();
        const entidad:any = await this.globalService.entidadDefault();

        this.bancoList.page       = this.bancoList.page+1;
        let params                 = {};
            params['take']         = 500;
            params['page']         = this.bancoList.page;
            params['search']       = this.bancoList.search;
            params['appID']        = this.globalService.appID;
            params['sedeID']       = entidad.sedeID;
            params['bancoID']     = null;
        this.loadBanco = true;
        this.globalService.requestPost('global/banco', params, 'jwt', token).subscribe(
            data => {
                if(data.validation == 'ok'){
                    let disabled = true;
                    if(data.list.length > 0){ 
                    	this.globalService.selects.bancos = data.list;
                        this.bancoList.list = data.list;
                        disabled = false;
                    }
                    this.loadBanco    = false;
                    this.loadBancoIni = true;
                    if(this.showSearch){
                    	this.focusSearch();
                    }
                }else{
                    this.globalService.failRequestHttp(data);
                }
            },
            error => {
                this.globalService.errorRequestHttp(error)
            }
        );
  	}

  	async bancoSelect(item, ev) {
        if(this.select == 'single') {
            this.modalController.dismiss({
                'bancoInfo': item
            });
        }else if(this.select == 'singleMultiple') {
            this.itemSelect.push(item);
            this.modalController.dismiss({
                'bancoInfo': item
            });
        }
    }

  	async dismissModal(ev) {
        this.modalController.dismiss({
            'bancoInfo': null
        })
    }
}



